import { Tooltip, Button, message } from 'antd'
import { isEmpty, uniqBy } from 'lodash'
import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import { t } from 'helpers/i18n'
import { Emitter } from 'helpers/events'
import { LIST_MODAL_CLEAR_SELECTION } from 'options/events'
import Icon from 'elements/Icon'
import Modal from 'elements/Modal'
import SelectIssueLimitLists from 'containers/IssueLimitLists/Select'

export default createChildListViewComponent({
  getStorageKey: (self) => `operators.formView.issueLimitLists`,
  entityName: entityNames.operators,
  childName: 'issueLimitLists',
  allowCustomize: (self) => true,
  allowCreate: (self) => false,
  extraTableButtons: (self) => (
    <>
      <Tooltip title={t('addIssueLimitList')} placement="topLeft">
        <Button
          type="primary"
          size="small"
          onClick={() => self.setState({ addFromIssueLimitListsVisible: true })}
          disabled={self.props.readOnly}
        >
          <Icon type="Add" bold />
        </Button>
      </Tooltip>
      <Modal
        title={t('addIssueLimitList')}
        visible={self.state.addFromIssueLimitListsVisible}
        onCancel={() => self.setState({ addFromIssueLimitListsVisible: false })}
        footer={
          <>
            <Button onClick={() => self.setState({ addFromIssueLimitListsVisible: false })}>
              {t('close')}
            </Button>
            <Button
              onClick={() => {
                const seed = Date.now() * -1
                const before = self.props.items
                const after = uniqBy(
                  [
                    ...self.props.items,
                    ...self.state.addFromIssueLimitListsItems.map((each, index) => ({
                      ...each,
                      id: seed - index,
                      operatorId: self.props.parentRecord.id,
                      issueLimitListActiveDescription: each.activeDescription,
                      issueLimitListName: each.name,
                    })),
                  ],
                  'issueLimitListId'
                )
                const delta = after.length - before.length
                const text = `${delta} ${t('itemsAdded')}`

                self.props.onChange(after)

                if (delta) {
                  message.success(text)
                } else {
                  message.warn(text)
                }

                Emitter.emit(LIST_MODAL_CLEAR_SELECTION)
              }}
              loading={self.state.addFromIssueLimitListsLoading}
              disabled={isEmpty(self.state.addFromIssueLimitListsItems)}
              type="primary"
            >
              {t('addToOperator')}
            </Button>
          </>
        }
        width={992}
      >
        <SelectIssueLimitLists
          onSelect={(values) => self.setState({ addFromIssueLimitListsItems: values })}
          mode="multiple"
          filterProps={{
            allowSelectLocations: true,
          }}
        />
      </Modal>
    </>
  ),
})()
